import { render, staticRenderFns } from "./side-by-side.vue?vue&type=template&id=72c5f1fa&scoped=true"
import script from "./side-by-side.vue?vue&type=script&lang=js"
export * from "./side-by-side.vue?vue&type=script&lang=js"
import style0 from "./side-by-side.vue?vue&type=style&index=0&id=72c5f1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5f1fa",
  null
  
)

export default component.exports